import { FolderX } from "lucide-react";

const NoProjectAccessPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center max-w-md mx-auto px-6">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center">
            <FolderX className="w-8 h-8 text-destructive" />
          </div>
        </div>
        <h2 className="text-2xl font-semibold text-foreground mb-2">
          No Active Project Assigned
        </h2>
        <p className="text-muted-foreground">
          Please contact your Test Manager to be added to an active project.
        </p>
      </div>
    </div>
  );
};

export default NoProjectAccessPage;
